import { store } from '../../../store'
import { updatePongTimeAction } from '../../../store/ws/actions'
import { MessageDataType } from '../types'

export interface WsPongData {
  type: 'pong'
}

export function onMessagePong(data: MessageDataType) {
  switch (data.type) {
    // Keep the connection alive and update the connection time, used to display in the 'ConnectionStatus' component
    case 'pong':
      pong()
      break
  }
}

function pong() {
  store.dispatch(updatePongTimeAction(new Date().getTime()))
}
